var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSideArrow = function SvgSideArrow(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BBB",
    fillRule: "evenodd",
    d: "M.265.874a1.012 1.012 0 0 0 0 1.411l4.17 4.217-4.17 4.216a1.005 1.005 0 0 0 0 1.41l.6.607a.985.985 0 0 0 1.394 0L6.43 8.52l1.304-1.306c.387-.388.389-1.02.003-1.414L6.439 4.475 2.26.267A.98.98 0 0 0 .864.268l-.6.606z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSideArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/side-arrow.24e1c51a279e85fa2ebc23925c4eefc8.svg";